import * as React from 'react';
import Login from '../login';
import { motion } from 'framer-motion';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TimelineIcon from '@mui/icons-material/Timeline';
import ShowChartIcon from '@mui/icons-material/ShowChart';

const Home = () => {
  return (
    <div className="relative flex flex-col md:flex-row w-full min-h-screen overflow-y-auto overflow-x-hidden bg-[#0b0e17] font-sans">

      {/* Subtle Background Effects with Circular Gradient */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none fixed">
        {/* Main circular gradient */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#009cd0]/25 via-[#131b2f]/90 to-[#0b0e17]"></div>

        <div className="absolute -top-[40%] -left-[20%] w-[80%] h-[80%] rounded-full bg-[#009cd0] opacity-[0.05] blur-[120px]"></div>
        <div className="absolute top-[60%] -right-[10%] w-[60%] h-[60%] rounded-full bg-[#006ae8] opacity-[0.06] blur-[100px]"></div>

        {/* Subtle grid pattern overlay */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px] opacity-30"></div>

        {/* Floating Icons Background */}
        <motion.div
          animate={{ y: [0, -20, 0], opacity: [0.08, 0.25, 0.08] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          className="absolute top-[15%] left-[5%] text-[#009cd0]"
        >
          <ShowChartIcon sx={{ fontSize: 160 }} />
        </motion.div>

        <motion.div
          animate={{ y: [0, 30, 0], opacity: [0.05, 0.15, 0.05] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut", delay: 1 }}
          className="absolute bottom-[15%] left-[35%] text-[#009cd0]"
        >
          <TrendingUpIcon sx={{ fontSize: 240 }} />
        </motion.div>
      </div>

      {/* Left side: Value Proposition & Branding */}
      <div className="relative flex flex-col justify-center w-full md:w-1/2 p-6 md:p-20 z-10 pt-10 md:pt-20 order-1">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <div className="inline-flex items-center px-4 py-1.5 mb-6 text-xs font-semibold tracking-wider text-[#009cd0] uppercase border border-[#009cd0]/30 rounded-full bg-[#009cd0]/10">
            <TimelineIcon className="mr-2" fontSize="small" />
            Quantitative Research & Trading
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold text-white leading-tight mb-6 tracking-tight">
            Plataforma de <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#009cd0] to-[#006ae8]">
              Analítica Financiera
            </span>
          </h1>

          <p className="text-base md:text-xl text-gray-300 font-light mb-8 md:mb-10 max-w-lg leading-relaxed">
            Transforma datos complejos de mercado en decisiones de trading inteligentes y accionables. Acceso seguro a herramientas cuantitativas de grado institucional.
          </p>

          <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4 text-xs md:text-sm text-gray-400 font-medium">
            <div className="flex items-center bg-[#0b0e17]/50 border border-white/5 py-2.5 px-4 rounded-lg shadow-sm">
              <TrendingUpIcon className="text-[#009cd0] mr-3" fontSize="small" />
              Estrategias Cuantitativas
            </div>
            <div className="flex items-center bg-[#0b0e17]/50 border border-white/5 py-2.5 px-4 rounded-lg shadow-sm">
              <TimelineIcon className="text-[#009cd0] mr-3" fontSize="small" />
              Análisis en Tiempo Real
            </div>
          </div>
        </motion.div>
      </div>

      {/* Right side: Login Component embedded in a glass card */}
      <div className="relative flex flex-col justify-center items-center w-full md:w-1/2 p-6 md:p-12 z-10 order-2 pb-12 md:pb-0">
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="w-full max-w-md relative"
        >
          {/* Subtle neutral backlight behind the login card to lift it without coloring it blue */}
          <div className="absolute -inset-1 bg-white rounded-3xl blur-xl opacity-5"></div>

          {/* Apple-style Frosted Glass Login Wrapper */}
          <div className="w-full backdrop-blur-[32px] backdrop-saturate-200 bg-white/[0.05] border border-white/[0.15] shadow-[0_8px_32px_0_rgba(0,0,0,0.8)] rounded-3xl p-6 md:p-8 relative overflow-hidden transition-all duration-300 hover:bg-white/[0.08]">
            {/* Extremely subtle inset highlight to give depth like iOS */}
            <div className="absolute inset-0 rounded-3xl pointer-events-none shadow-[inset_0_1px_1px_rgba(255,255,255,0.2)]"></div>
            <Login />
          </div>

          <div className="mt-8 text-center text-[10px] md:text-xs text-gray-400">
            <p className="drop-shadow-sm">QRT Trading Webtool © {new Date().getFullYear()}. Todos los derechos reservados.</p>
            <p className="mt-1 drop-shadow-sm">Solo para personal autorizado.</p>
          </div>
        </motion.div>
      </div>

    </div>
  );
}

export default Home;
